export const ApiURL =
  process.env.NODE_ENV === 'development' ? 'api/' :
    process.env.REACT_APP_ENV === "PRD"
      ? "https://demand-forecast-api.linde.com/api/"
      : "https://tst.demand-forecast-api.linde.com/api/";
